import { Rating, Stack } from '@mui/material'
import { useTranslations } from 'next-intl'

export const RatingProduct = ({ rating, review }: { rating: number; review: number }) => {
  const t = useTranslations('Product')
  return (
    <Stack direction={'row'} alignItems={'center'} gap={2}>
      {rating && rating > 0 ? (
        <Rating style={{ color: 'var(--sub-color)', fontSize: '.75rem' }} disabled defaultValue={rating} />
      ) : (
        <div className="h-[22px]"></div>
      )}
      {review && review > 0 ? <span className="text-sub-color">{`${review} ${t('reviews')}`}</span> : null}
    </Stack>
  )
}
